import React, {useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import CloseIcon from '@mui/icons-material/Close';

// STYLE
import "./style.css";
import axios from "axios";
import http, {getDomain} from "../../api/http";
import {ImgIcons, UploadImgText} from "./myDropzoneOne";

const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
    padding: '15px',
    width: '100%',
    border: '1px dashed #eee'
};


const inputStyle = {
    display: "block",
    width: "100%",
    border: "1px solid #eaeaea",

};

const thumbFull = {
    display: "block",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 170,
    height: 170,
    padding: 4,
    position: "relative",
    boxSizing: "border-box"
};
const thumb = {
    display: "block",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 170,
    height: 170,
    padding: 4,
    position: "relative",
    boxSizing: "border-box"
};

const thumbInner = {
    display: "flex",
    minWidth: 0,
    height: 170,
    overflow: "hidden",
    maxHeight: '100%',
    maxWidth: '100%',

};

const img = {
    display: "block",
    width: "auto",
    height: "100%",
    objectFit: "cover"
};

let changeInd;

const buildImageSrc = (domain, fileUrl) => {
    if (!fileUrl) return '';
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    const normalizedPath = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`;
    return `${domain}${normalizedPath}`;
};

const getFileMeta = (file) => {
    if (!file) return { url: '', name: '' };
    const nested = file.file || {};
    const url = file.url || nested.url || '';
    const name = file.originalName || file.name || nested.originalName || nested.name || '';
    return { url, name };
};

function Dropzone(props) {
    const [cd, setCd] = useState(new Date().getTime())
    const domain = getDomain();
    const files = props.files;
    const {getRootProps, getInputProps, open} = useDropzone({
        accept: "image/*",
        onDrop: (acceptedFiles) => {
            uploadToServer(acceptedFiles, (file) => {
                if (changeInd) {
                    let _files = [...files];
                    _files[changeInd.ind] = file;
                    props.onChange && props.onChange([..._files])

                } else {
                    let _files = [...files, file];
                    props.onChange && props.onChange(_files)
                }
                changeInd = null;

            })
        }
    });

    const uploadToServer = (_files, cb) => {
        let file = (_files || files)[0];
        const formData = new FormData();
        formData.append("file", file);

        http.post("/api/media/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(response => {
                return response.data;

            })
            .then(data => {
                console.log("File uploaded successfully:", data);
                cb && cb(data)
            })
            .catch(error => {
                console.error("Error uploading file:", error);
            });
    }

    const removeFile = (ind) => () => {
        const newFiles = [...files];
        newFiles.splice(ind, 1);
        props.onChange && props.onChange(newFiles)
    };

    // const thumbs = ;

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach((file) => URL.revokeObjectURL(file.preview));
    }, [files]);
    let isEditor = (global || {}).isEditor;

    return (
        <div className={'asideWrap'}>

            <section className="container z1000 flex" data-fade>
                <div
                    style={{display: "none", zIndex: 10000, opacity: 0, height: 0, overflow: "hidden"}}
                    {...getRootProps({className: "dropzone"})}
                    onClick={open}
                >
                    <input {...getInputProps()} style={{opacity: 0}}/>
                    <p style={{opacity: 0}}>Click to load files</p>
                </div>
                <>
                    <hr style={{opacity: .2}}/>

                    <aside style={{...thumbsContainer}} data-animch className={'z1000'}>
                        {(files || []).map((file, ind) => {
                            const { url: fileUrl, name: fileName } = getFileMeta(file);
                            const imgSrc = buildImageSrc(domain, fileUrl);
                            if (!imgSrc) return null;
                            return <>
                                <div style={thumbFull} key={`${fileUrl || fileName || ind}`} className={'rel ib'} data-rel data-img-hover>

                                    <div style={thumbInner}>
                                        <img src={imgSrc} style={img} alt={fileName || `file-${ind}`}/>
                                    </div>
                                    <div data-img-hover-wrap>
                                        <ImgIcons onDelete={() => {
                                            props.onChange && props.onChange(files.filter((it, _ind) => ind !== _ind))
                                        }}
                                                  onChange={() => {
                                                      changeInd = {ind}
                                                      open()
                                                  }}
                                        ></ImgIcons>
                                        <div
                                            data-img-child-wrap
                                            style={{
                                                width: 'calc(100% - 0px)',
                                                position: 'absolute',
                                                boxSizing: 'border-box',
                                                zIndex: 10,
                                                marginTop: '0'
                                            }}>
                                            <div>
                                                <input
                                                    disabled={!isEditor}
                                                    type="text" placeholder={'Image title'}
                                                    value={
                                                        typeof file.shortTitle === 'object' 
                                                            ? file.shortTitle[props.language || 'en'] || ''
                                                            : file.shortTitle || ''
                                                    }
                                                    onChange={(e) => {
                                                    let _files = [...files];
                                                    const currentShortTitle = _files[ind].shortTitle || {};
                                                    const updatedShortTitle = typeof currentShortTitle === 'object'
                                                        ? { ...currentShortTitle, [props.language || 'en']: e.target.value }
                                                        : { [props.language || 'en']: e.target.value };
                                                    _files[ind] = {..._files[ind], shortTitle: updatedShortTitle}
                                                    props.onChange && props.onChange(_files)
                                                }}
                                                />
                                            </div>
                                            <textarea
                                                className={'z1000 textareaZ'}
                                                style={{heigth: '200px'}}
                                                disabled={!isEditor}

                                                placeholder={'Image description'}
                                                value={
                                                    typeof file.title === 'object' 
                                                        ? file.title[props.language || 'en'] || ''
                                                        : file.title || ''
                                                }
                                                onChange={(e) => {
                                                let _files = [...files];
                                                const currentTitle = _files[ind].title || {};
                                                const updatedTitle = typeof currentTitle === 'object'
                                                    ? { ...currentTitle, [props.language || 'en']: e.target.value }
                                                    : { [props.language || 'en']: e.target.value };
                                                _files[ind] = {..._files[ind], title: updatedTitle}
                                                props.onChange && props.onChange(_files)
                                            }}/>
                                        </div>
                                    </div>

                                    {/*<div onClick={(e) => {*/}
                                    {/*    removeFile(ind);*/}
                                    {/*    const newFiles = [...files];*/}
                                    {/*    newFiles.splice(ind, 1);*/}
                                    {/*    props.onChange && props.onChange(newFiles)*/}
                                    {/*    e.preventDefault();*/}
                                    {/*    e.stopPropagation();*/}
                                    {/*    return null;*/}
                                    {/*}} style={{*/}
                                    {/*    padding: '3px',*/}
                                    {/*    opacity: '.1',*/}
                                    {/*    position: 'absolute', right: 0}} data-hover>✖</div>*/}
                                </div>

                            </>
                        })}

                        <div style={{...thumb, textAlign: 'center', cursor: 'pointer'}} onClick={open}>
                            <UploadImgText></UploadImgText>
                            {/*<b data-hover2 data-center>*/}
                            {/*    Upload<br/>Image*/}
                            {/*</b>*/}
                        </div>


                    </aside>

                    <hr style={{opacity: .2}}/>
                </>


            </section>
        </div>
    );
}

export default Dropzone;
